"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const OpIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("rect", { rx: "4", ry: "4", width: "24", height: "24" }),
    react_1.default.createElement("g", { fill: "white" },
        react_1.default.createElement("path", { d: "M15 6H4C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H15V6Z" }),
        react_1.default.createElement("path", { d: "M4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H7V11H4Z" }),
        react_1.default.createElement("path", { d: "M9 11V13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H9Z" }),
        react_1.default.createElement("path", { d: "M4 16C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18H12V16H4Z" }),
        react_1.default.createElement("path", { d: "M17 8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H17V8Z" }),
        react_1.default.createElement("path", { d: "M14 16V18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H14Z" }))));
exports.OpIcon = OpIcon;
exports.default = exports.OpIcon;
